import{scenarioTestTableActions} from './../constants';
const defaultTestData = {
    testData: []
};
//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }


const scenarioTestTableReducers =  (state = defaultTestData, action) => {
    switch(action.type) {
        case scenarioTestTableActions().addTestData:
            return {
                testData: action.testData
            }
        case scenarioTestTableActions().editTestData:
            return {
                testData: state.testData.map( (item) => {
                    if( item.test_point_id === action.testData.test_point_id ) {
                        return action.testData
                    } else {
                        return item
                    }
                })
            }
        case scenarioTestTableActions().deleteTestdata:
            return {
                testData: state.testData.filter( (item) => {
                    if(item.test_point_id === action.test_point_id){
                        return false
                    } else {
                        return true
                    }
                })
            }
        default:
            return state
    }
}

export default scenarioTestTableReducers;